<template>
  <content-div>

    <div class="svTitArea subscribe bg">
    </div>

    <div class="sub_copy" style="margin: 20px;">
      <p class="sub_subTitle tac">당신의 BMW를 더 오래, 한결같이.</p>
      <p class="sub_title tac" style="margin-top: 5px;">
        BMW 공식 차량 관리 구독 서비스 <br>
        ServiceCare+를 만나보세요.
      </p>
    </div>

    <div class="contArea tpd" style="margin:0px;padding:0px">
      <pkg-tab
          :term.sync="term"
          :date.sync="date"
          :pkg.sync="pkg"
          :vehicle.sync="vehicle"
      ></pkg-tab>

      <div :class="(!$store.state.isDev && !$store.state.isApp) ? 'btnBox' : 'btnBoxCs'" >
        <!-- dev 개발모드 -->
        <a v-if="$store.state.isDev" 
          class="btnL fixedBtn" :class="Const.TEST_EMAIL.includes($store.state.user.vtg_id)
            && ['211.44.220.121','172.17.0.1'].includes($store.state.envServer.ip) ? 'test': ''"
          @click="checkUser">
          BMW ServiceCare+ 서비스 구독 신청
        </a>
        
        <a v-else-if="Const.TEST_EMAIL.includes($store.state.user.vtg_id)"
           class="btnL fixedBtn" :class="Const.TEST_EMAIL.includes($store.state.user.vtg_id)
            && ['211.44.220.121','172.17.0.1'].includes($store.state.envServer.ip) ? 'test': ''"
           @click="checkUser">
          BMW ServiceCare+ 서비스 구독 신청
        </a>

        <!-- App이 아닐경우 -->
        <template v-else-if="!$store.state.isApp">
          <div class="subBlock"></div>
          <div class="slogan01 mgb">현재 BMW ServiceCare+ 서비스 신청은 App에서만 가능합니다.</div>
          <button-app-download></button-app-download>
        </template>

        <a v-else class="btnL fixedBtn" 
          @click="checkUser">
          BMW ServiceCare+ 서비스 구독 신청
        </a>
      </div>

    </div>

    <popup-alert v-if="activateErr"
                 title="안내"
                 :btn_cancel="btnCancelFlag"
                 :btn_submit_title="btnSubmitTitle"
                 @close="closePopupErr"
    >
      <popup-msg :type="popupMsg">
        <div v-if="popupMsg == 'PKGS_ENABLE'">
          <br>
          <span v-for="(pkgs, enable_title) in pkgsEnable" :key="`enable-${enable_title}`">
            <span v-for="(pkg,i) in pkgs" :key="`pkg-${pkg.title}`">
              {{pkg.title}} 
              <span v-if="i != (pkgs.length-1)">or<br v-if="enable_title == '60개월 초과 ~ 96개월 이하'"></span>
              <span v-else style="margin:0px 5px;">:</span> 
            </span>
            <br v-if="enable_title == '60개월 초과 ~ 96개월 이하'">
            {{enable_title}}<br>
          </span>
        </div>
      </popup-msg>

    </popup-alert>

    <popup-alert v-if="activateJoin" title="BMW ServiceCare+ 서비스 신청 준비" btn_cancel @close="closePopupJoin">
      <popup-msg type="SUBSC_INFO"></popup-msg>
    </popup-alert>

    <popup v-if="activate">
      <template #title>BMW ServiceCare+ 서비스신청</template>
      <template #content>
        <div>서비스 받으실 차량을 선택해 주세요.</div>
        <table class="tbl-form alignC pm-tbl-form">
          <thead>
          <tr>
            <th>선택</th>
            <th class="WBkeepAll">차량 모델명</th>
            <th class="WBkeepAll">자동차 등록번호</th>
          </tr>
          </thead>
          <tbody class="pmTblFormTbody">
          <tr v-for="(item, index) in selectVehicleList" :key="index">
            <th>
              <input v-show="false" type="radio" :id="'vehicle-'+index" :value="index" v-model="selectVehicleItem">
              <label :for="'vehicle-'+index"><span v-show="false"></span></label>
            </th>
            <td>{{item.model}}</td>
            <td>{{item.num_reg}}</td>
          </tr>
          </tbody>
        </table>
      </template>

      <template #button>
        <span><a @click="closePopup(false)">취소</a></span>
        <span><a @click="closePopup(true)" class="fCol1">확인</a></span>
      </template>

    </popup>

  </content-div>
</template>


<script>
import {api} from '@/api'
import axios from 'axios'
import Const from '../../helpers/Const'
import Popup from '@/components/Popup/Popup.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import PopupMsg from '@/components/Popup/PopupMsgTemplate'
import PkgTab from '@/views/Pkg/PkgTabView.vue'
import ButtonAppDownload from '@/components/Button/ButtonAppDownload.vue'

export default {

  components: {
    Popup,
    PopupAlert,
    PkgTab,
    PopupMsg,
    ButtonAppDownload,
  },

  data() {
    return {
      Const,
      activate: false,
      activateErr: false,
      activateJoin: false,

      popupMsg: '',
      selectVehicleItem: 0,
      selectVehicleList: [],
      subscVehicle: [],
      userCheck: false,

      term: 0,
      date: null,
      pkg: 0,
      vehicle: 0,
    }
  },

  computed: {
    btnSubmitTitle() {
      return (this.popupMsg == 'NO_VTG_USER') ? '로그인'
          : (this.popupMsg == 'NO_VTG_VEHICLES') ? '차대번호 등록하기'
              : '확인';
    },

    btnCancelFlag(){
      return ['NO_VTG_USER','NO_VTG_VEHICLES'].includes(this.popupMsg);
    },

    selectTermVehicleChk(){
      let bool = false;
      let pkgVehicleCat = this.$store.state.vehicleCats[this.pkg];
      let vehicleCat = null;

      if(pkgVehicleCat) {
        try {
          //선택한 차량
          vehicleCat = pkgVehicleCat[this.vehicle];
          if(vehicleCat.costs[this.term].state) bool = true;
        } catch (error) {
          vehicleCat = null;
        }
      }
      return bool;
    },

    pkgsEnable() {
        let pkgs = this.$store.state.pkgs;
        let pkgVehicleCats = this.$store.state.vehicleCats;
        let array = [];
        let vhicleCat = null;
        let costs = [];
        let enable_title = '';

        Object.keys(pkgs).forEach(pkg_id => {
          enable_title = '';
          vhicleCat = null;

          try {
            vhicleCat = pkgVehicleCats[pkg_id][this.vehicle];
            costs = vhicleCat.costs.filter(cost => cost.state);

            enable_title += costs[0].unit_min-1 + '개월 초과 ';
            if((costs[costs.length-1].unit_max != this.Const.PKG_VEHICLE_CAT_COST_UNIT_MAX))
              enable_title +=  `~ ${costs[costs.length-1].unit_max}개월 이하`

            array.push({
              title: pkgs[pkg_id].pkg_title,
              enable_title,
            });

          } catch (error) {
            array = [];
          }
        });

        array = array.reduce(function (carry, el) {
          var group = el['enable_title'];

          if (carry[group] === undefined) {
              carry[group] = []
          }

          carry[group].push(el)
          return carry
        }, {})



        return array;
      },
  },

  methods: {
    //서비스차량 선택 후 알람창 닫기 & 라우팅
    closePopup(submit) {
      this.activate = false
      if(submit) this.activateJoin = true;
    },

    closePopupErr(ok) {
      this.activateErr = false
      if (!ok) return;


      if(this.popupMsg == 'NO_VTG_USER') {
        return '';
      } else if(this.popupMsg == 'NO_VTG_VEHICLES') {
        return '';
      } else if(this.popupMsg == 'NO_PLUS_USER') {
        //return this.oasRedirect('/bmw/login');
        return this.vtgRedirect('/bmw/login');
      } else if(this.popupMsg == 'NO_PLUS_VEHICLES') {
        //return this.oasRedirect('/bmw/user/vehicle');
        return this.vtgRedirect('/bmw/user/vehicle');
      } else if (this.popupMsg == 'NO_ABLE_SUBSC_VEHICLE') {
        this.$router.push('/subscStatus')
      }
    },

    closePopupJoin(submit) {
      this.activateJoin = false;
      if(submit)
        this.$router.push(`/subscApply/term?pkg=${this.pkg}&vehicle=${this.vehicle}&date=${this.date}&term=${this.term}`);
    },

    // 유저 정보 체크
    checkUser() {
      if (this.vehicle === 0){
        this.popupMsg = 'SUBSC_REQ_VEHICLE';
        this.activateErr = true;
        return;
      }
      
      //if (this.$store.state.pkgs[this.pkg].is_assurance && (this.date === null || this.date === undefined || this.date === ''))
      if((this.date === null || this.date === undefined || this.date === ''))
      {
        this.popupMsg = 'SUBSC_REQ_REG_DATE';
        this.activateErr = true;
        return;
      }

      this.$store.commit('setBtnLoading', true);

      this.checkSelectTermVehicle()
    },

    checkSelectTermVehicle(){
      if (this.selectTermVehicleChk) {
        this.checkPlusUserVehicles()
      } else {
        this.popupMsg = 'PKGS_ENABLE';
        this.activateErr = true;
        this.$store.commit('setBtnLoading', false);
      }
    },

    // plus 등록된 차량 유무 체크
    checkPlusUserVehicles() {
      const plusVehicles = this.$store.state.user.vehicles
      this.getUserPrimeVehicles(plusVehicles)
    },

    // prime에 등록된 차량리스트 get (plus 등록차량과 비교해 현재 서비스중 차량 걸러내기)
    getUserPrimeVehicles(items) {
      // console.log( this.$store.state.user );return;
      // if( !this.$store.state.user_scp.vtg_id && this.$store.state.user_scp.id > 0 ) {
      // alert( 'user_scp:' + JSON.stringify( this.$store.state.user_scp ) );
      // console.log( this.$store.state.user_scp );return;
      // alert( JSON.stringify( this.$store.state.user_scp ) );
      if( !this.$store.state.user_scp.vtg_id && this.$store.state.user_scp.id > 0 ) {
        this.$store.commit('setPopup401', true);
        this.$store.commit('setBtnLoading', false);
        return;
      }

      //plus_id가 있지만 token이 존재하지 않을경우 (prime 내 미가입상태)
      if(this.$store.state.user.id == 0){
        this.setAvailVehicles()
        return;
      }

      axios.get(`${api.users}/${this.$store.state.user.id}`)
          .then(({data}) => {
            const vehicles = data.data.vehicles;
            const subscs = data.data.subscs;

            vehicles.forEach((vehicle) => {

              subscs.filter( (subsc_f) => subsc_f.vehicle_num_id == vehicle.num_id )
                  .forEach((subsc) => {  // prime 에 등록된 차량 = 최소 한 개의 서비스정보는 가지고 있음
                    if (subsc.state == Const.SUBSC_STATE.ENABLE) {   // 서비스중인 데이터가 있을 경우 서비스중인 차량 리스트에 push
                      this.subscVehicle.push(vehicle.num_id)
                    }
                  })

            })

            this.setAvailVehicles(items)
          })
          .catch((error) => {
            this.popupMsg = this.errorMsg(error);
            this.activateErr = true
            this.$store.commit('setBtnLoading', false);
          })
    },

    // 서비스 가능한 차량만 선택할 수 있도록 리스트 제작
    setAvailVehicles() {
      this.activate = false

      if(this.$store.state.pkgs[this.pkg].is_assurance){
        this.activateJoin = true;
      }else {
        this.closePopupJoin(true);
      }
      this.$store.commit('setBtnLoading', false);
    },


  }
}
</script>

<style lang="css" scoped>
  .btnBoxCs {
    margin: 30px auto 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .fixedBtn {
    position:fixed;
    bottom:0;
    z-index:999;
    width:100%;
    margin:0;
    padding:0;
  }
  .fixedBtn.test {
    bottom:40px;
    z-index:1;
  }
</style>

